const initialSpinnerValues =
{
    showSpinner: false,
    modalPopShow: false,
    // 
    digitokenno: "",
}

export default function SpinnerReducer(spinnerValues = initialSpinnerValues, action) {
    switch (action.type) {
        case "SHOW_SPINNER":
            return {
                ...spinnerValues,
                showSpinner: true
            };

        case "HIDE_SPINNER":
            return {
                ...spinnerValues,
                showSpinner: false
            };


            case "MODALPOPSHOW":
            return { ...spinnerValues, modalPopShow: action.payload };

            case "DIGITOKENNO":
            return { ...spinnerValues, digitokenno: action.payload };
        default:
            return spinnerValues;
    }
}